// extracted by mini-css-extract-plugin
module.exports = {"h720i19":"h720i19","a1nxwrnm":"a1nxwrnm"};